import { INDENTS } from 'vars/index'

export const Direction = {
  Row: 'row',
  Column: 'column',
} as const
export type Direction = (typeof Direction)[keyof typeof Direction]

export const JustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type JustifyContent =
  (typeof JustifyContent)[keyof typeof JustifyContent]

export const AlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
} as const
export type AlignItems = (typeof AlignItems)[keyof typeof AlignItems]

export const Fluid = {
  Horizontal: 'horizontal',
  Vertical: 'vertical',
  Both: 'both',
  None: 'none',
} as const
export type Fluid = (typeof Fluid)[keyof typeof Fluid]

type PaddingKey =
  | 'SIZE_0'
  | 'SIZE_15'
  | 'SIZE_35'
  | 'SIZE_60'
  | 'SIZE_100'
  | 'SIZE_140'
export const Paddings: Record<
  PaddingKey,
  readonly [string, string, string, string]
> = {
  SIZE_0: [
    INDENTS.INDENT_0,
    INDENTS.INDENT_0,
    INDENTS.INDENT_0,
    INDENTS.INDENT_0,
  ],
  SIZE_15: [
    INDENTS.INDENT_0,
    INDENTS.INDENT_15,
    INDENTS.INDENT_0,
    INDENTS.INDENT_15,
  ],
  SIZE_35: [
    INDENTS.INDENT_0,
    INDENTS.INDENT_35,
    INDENTS.INDENT_0,
    INDENTS.INDENT_35,
  ],
  SIZE_60: [
    INDENTS.INDENT_0,
    INDENTS.INDENT_60,
    INDENTS.INDENT_0,
    INDENTS.INDENT_60,
  ],
  SIZE_100: [
    INDENTS.INDENT_0,
    INDENTS.INDENT_100,
    INDENTS.INDENT_0,
    INDENTS.INDENT_100,
  ],
  SIZE_140: [
    INDENTS.INDENT_0,
    INDENTS.INDENT_140,
    INDENTS.INDENT_0,
    INDENTS.INDENT_140,
  ],
} as const

export type Padding = (typeof Paddings)[keyof typeof Paddings]
